import * as DialogPrimitive from '@radix-ui/react-dialog'
import { cn } from '@core/utils'
import Icon from '../Icon/Icon'
import DialogOverlay from './DialogOverlay'
import DialogPortal from './DialogPortal'

const DialogContent = ({
    className,
    children,
    showCloseButton = true,
    ...props
}: React.ComponentProps<typeof DialogPrimitive.Content> & {
    showCloseButton?: boolean
}) => {
    return (
        <DialogPortal data-slot="dialog-portal">
            <DialogOverlay />
            <DialogPrimitive.Content
                data-slot="dialog-content"
                className={cn(
                    'fixed inset-0 z-50 m-auto grid max-h-fit w-full max-w-[calc(100%-2rem)] overflow-hidden rounded-[20px] bg-semantic-content-brand data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 sm:max-w-lg',
                    className,
                )}
                {...props}>
                {children}
                {showCloseButton && (
                    <DialogPrimitive.Close
                        data-slot="dialog-close"
                        className="focus:outline-hidden absolute right-3 top-3 z-10 grid size-8 place-items-center rounded-full bg-tint-ink-10 backdrop-blur-[20px] duration-300 active:scale-95 disabled:pointer-events-none">
                        <Icon
                            name="close"
                            size={16}
                            color="var(--content-ink-inverse)"
                        />
                        <span className="sr-only">Close</span>
                    </DialogPrimitive.Close>
                )}
            </DialogPrimitive.Content>
        </DialogPortal>
    )
}

DialogContent.displayName = 'DialogContent'

export default DialogContent
